export class RmZonesDropDownDto{
    zoneId:number;
    zoneName:string;

    
    constructor(zoneId:number, zoneName:string){
        this.zoneId = zoneId;
        this.zoneName = zoneName;
    }
}